import { api } from '../../../../app/auth/apiSlice';

export interface Feedback {
  id: number;
  created_at: string;

  is_ignored: boolean;
  is_submitted: boolean;
}

export interface FeedbackData {
  results: Feedback[];
}

const feedbackApi = api
  .enhanceEndpoints({ addTagTypes: ['Feedback'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      getFeedbackData: builder.query<FeedbackData, void>({
        query: () => {
          return `v1/survey/feedbacks/`;
        },
        providesTags: ['Feedback'],
      }),
      addFeedback: builder.mutation({
        query: (newFeedback) => ({
          url: 'v1/survey/feedbacks/',
          method: 'POST',
          body: newFeedback,
        }),
        invalidatesTags: ['Feedback'],
      }),
      updateFeedback: builder.mutation({
        query: ({ data: newFeedback, id }) => {
          return {
            url: `v1/survey/feedback/${id}`,
            method: 'PATCH',
            body: newFeedback,
          };
        },
        invalidatesTags: ['Feedback'],
      }),
    }),
  });

export const {
  useGetFeedbackDataQuery,
  useAddFeedbackMutation,
  useUpdateFeedbackMutation,
} = feedbackApi;
